import request from "@/utils/request";

export const getWarehouseReceipt = (hqPackingListId: string) =>
  request({
    url: `/warehouse-receipts/${hqPackingListId}`,
    method: "GET"
  });

export const getWarehouseReceiptOriginalInfo = (params: { hqPackingListId: string }) =>
  request({
    url: `/warehouse-receipts/original-information`,
    method: "GET",
    params
  });


export const createWarehouseReceipt = (data: any) =>
  request({
    url: `/warehouse-receipts`,
    method: "POST",
    data
  });

export const updateWarehouseReceipt = (id: string,data: any) =>
    request({
        url: `/warehouse-receipts/${id}`,
        method: "PUT",
        data
    });

export const getWarehouseReceipts = (params: { hqPackingListId: string }) =>
  request({
      url: `/warehouse-receipts`,
      method: "GET",
      params
  });
